<template>
  <div class="container">
    <div v-show="!authenticated">
      <p class="h3 mt-4 text-center">Please Login And Try Again</p>
    </div>
    <div v-show="authenticated">
      <div class="row justify-content-md-center">
        <div class="col-auto">
          <b-input-group
            size="lg"
            class="mb-4 mt-4"
          >
            <b-input-group-prepend is-text>
              <b-icon icon="search"></b-icon>
            </b-input-group-prepend>
            <b-form-input
              type="search"
              placeholder="Search Selections"
              :state="true"
              v-model="search"
            ></b-form-input>
          </b-input-group>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div
          class="col-md-2 col-lg-3 col-sm-1 mb-4 text-center"
          v-for="selection in filteredSelections"
          v-bind:key="selection.email"
        >
          <b-button
            pill
            size="lg"
            class="scale-on-hover folder"
            @click="showOptionsConfirm(selection.name,selection.email)"
          >
            <b-icon
              icon="images"
              font-scale="6"
              style="color:rgba(0, 111, 25, 0.89);"
            ></b-icon>
          </b-button>
          <br />
          <b-badge
            variant="info"
            pill
          >{{selection.email}}</b-badge>
        </div>
      </div>
      <b-modal
        size="sm"
        ref="options-confirm"
        centered
        title="Available Actions"
      >
        <div class="d-block text-center">
          <h6>
            Click on the action you want perform
          </h6>
        </div>
        <template v-slot:modal-footer>
          <b-button-group
            class="float-right"
            size="sm"
          >
            <b-button
              variant="info"
              class="mr-3"
              @click="download()"
            >Download</b-button>
            <b-button
              variant="warning"
              class="mr-3"
              @click="handleDelete()"
            >Delete</b-button>
            <b-button
              variant="success"
              @click="handleCancel"
            >Cancel</b-button>
          </b-button-group>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'clientgallery',
  components: {},
  data () {
    return {
      authenticated: false,
      togleState: true,
      selections: [],
      search: '',
      deleteSelection: '',
      downloadFile: ''
    }
  },
  computed: {
    filteredSelections () {
      return this.selections.filter(image => {
        return image.email.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    loadbaguettBoxForGal: function () { },
    showPrintConfirm () {
      this.$refs['print-confirm'].show()
    },
    handlePrint () {
      // this.$refs['print-confirm'].close();
      this.$bvToast.toast('Thank You', {
        title: 'We Have Recorded Your Decision',
        variant: 'success',
        toaster: 'b-toaster-top-center',
        solid: true
      })
    },
    download () {
      axios({
        url: this.downloadFile,
        method: 'GET',
        responseType: 'blob'
      }).then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]))
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', this.downloadFile.split('/').pop())
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    showOptionsConfirm (downloadlink, email) {
      this.deleteSelection = email
      this.downloadFile = downloadlink
      this.$refs['options-confirm'].show()
    },
    handleCancel () {
      this.$refs['options-confirm'].hide()
    },
    handleDelete () {
      axios
        .delete('gallery/selections/' + this.deleteSelection)
        .then(response => {
          this.handleCancel()
          this.$bvToast.toast('Album Deletion Successful', {
            title: 'Success',
            variant: 'success',
            toaster: 'b-toaster-top-center',
            solid: true
          })
          this.loadSelections()
        })
    },
    loadSelections () {
      axios.get('gallery/selections').then(response => {
        this.selections = response.data
      })
    }
  },
  beforeMount () { },
  mounted () {
    if (!this.$cookies.get('zic-login')) {
      this.authenticated = false
    } else {
      this.authenticated = true
    }
    this.loadSelections()
  }
}
</script>

<style scoped>
.folder:hover,
.folder:focus,
.folder:active {
  background-color: #a08d02b8 !important; /*#007bff*/
}
.folder {
  background-color: #fdde054a !important; /*#007bff*/
}

.scale-on-hover:hover {
  transform: scale(1.05);
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.15) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Selections.vue